<app-job-header></app-job-header>
<div class="banner-container">
  <div class="text-container">
    <h1>
      Connecting <span class="highlight-text">Quality</span> <br /><span
        class="highlight-text"
        >Teachers</span
      >
      with <span class="highlight-text">Leading Schools</span> <br />
      Across India
    </h1>
    <p class="subtitle">
      Empowering Schools with Talented Educators. Helping Teachers <br />
      Find Their Dream Jobs.
    </p>
    <div class="button-container">
      <button mat-stroked-button class="post-job-button">Post a job</button>
      <button mat-raised-button color="primary" class="find-role-button">
        Find Your Next Teaching Role
      </button>
    </div>
  </div>

  <div class="image-container">
    <img
      src="../../assets/images/job_page.png"
      alt="Illustration of teachers and job listing"
    />
  </div>
</div>
<div class="trusted-container">
  <h2>Trusted by community of 10000+ teachers and schools</h2>
  <div *ngIf="logoUrl?.length">
    <div class="carousel-container">
      <div class="carousel-images">
        <!-- <ng-image-slider [animationSpeed]="1" [images]="school.gallery" #gallery></ng-image-slider> -->
        <!-- <ng-image-slider [imageSize]="imageSize" [autoSlide]="autoSlide" [infinite]="infiniteSlide"
              [showArrow]="true" [animationSpeed]="4" [slideImage]="4" [images]="logoUrl" #gallery></ng-image-slider> -->
        <!-- <ng-image-slider [imageSize]="imageSize" [autoSlide]="autoSlide" [infinite]="infiniteSlide"
                    [showArrow]="false" [animationSpeed]="1" [images]="logoUrl" #gallery></ng-image-slider> -->
      </div>
    </div>
  </div>
</div>
<div class="wa-container">
  <div class="whatsapp-section">
    <div class="whatsapp-card">
      <div class="whatsapp-icon">
        <img src="../../assets/images/whatsappicon.svg" alt="WhatsApp Icon" />
      </div>
      <div class="whatsapp-text">
        <h3>Stay connected and informed!</h3>
        <p>
          Join our WhatsApp community for exclusive updates, promotions, and
          more
        </p>
      </div>
      <a
        href="https://chat.whatsapp.com/EDdRZIoKcBZ3MGMCe9mCid"
        target="_blank"
        mat-raised-button
        color="primary"
        class="join-now-button"
        >Join Now</a
      >
    </div>
  </div>
</div>

<div class="platform-description">
  <p>
    Inforida Teacher Job Market is your go-to platform for connecting schools
    and teachers across India. Whether you're a school administrator looking to
    hire talented teachers or an educator seeking your next teaching position,
    we make it easy for you to find the right fit. Explore thousands of
    opportunities tailored to your preferences or post job openings for free
    today!
  </p>
</div>

<div class="key-features-container">
  <!-- For Teachers Feature Card -->
  <div class="feature-card">
    <div class="content-container">
      <div class="card-image">
        <img
          src="../../../assets/images/for-teachers.png"
          alt="Illustration for Teachers"
        />
      </div>
      <div class="card-content">
        <h3>For Teachers</h3>
        <p class="feature-title">Job Search Made Simple</p>
        <p class="feature-desc">
          Filter jobs by location, board, level, subject, position <br />and
          experience level.
        </p>
        <br />
        <p class="feature-title">Seamless Application Process</p>
        <p class="feature-desc">
          Apply for jobs directly through the platform.
        </p>
        <br />
        <button mat-raised-button color="primary" class="find-role">
          Search Job
        </button>
      </div>
    </div>
  </div>

  <!-- For Schools Feature Card -->
  <div class="feature-card">
    <div class="content-container">
      <div class="card-image">
        <img
          src="../../../assets/images/for-schools.png"
          alt="Illustration for Teachers"
        />
      </div>
      <div class="card-content">
        <h3>For Schools</h3>
        <p class="feature-title">Post Jobs in Minutes</p>
        <p class="feature-desc">
          Easily create job posts and reach a large pool<br />
          of qualified teachers.
        </p>
        <br />
        <p class="feature-title">Track Applicants</p>
        <p class="feature-desc">
          Monitor application statuses and<br />
          communicate with potential hires directly.
        </p>
        <br />
        <button mat-raised-button color="primary" class="find-role">
          Post a Job
        </button>
      </div>
    </div>
  </div>
</div>

<div class="why-inforida-container">
  <h2 class="section-title">Why you should choose inforida jobs</h2>

  <div class="feature-cards">
    <!-- First Feature Card -->
    <div class="feature-card">
      <div class="icon">
        <img
          src="../../../assets/images/free-post.png"
          alt="Free Posting Icon"
        />
      </div>
      <h3>Free Posting and Apply</h3>
      <p>
        Post jobs and apply<br />
        without any cost, making <br />
        hiring and job seeking <br />
        easy and accessible.
      </p>
    </div>

    <!-- Second Feature Card -->
    <div class="feature-card">
      <div class="icon">
        <img
          src="../../../assets/images/search-filters.png"
          alt="Search Filter Icon"
        />
      </div>
      <h3>Advanced Search & Filters</h3>
      <p>
        Use advanced search and filters <br />
        to find a perfect job<br />
        for hastlefree<br />
        job search experience.
      </p>
    </div>

    <!-- Third Feature Card -->
    <div class="feature-card">
      <div class="icon">
        <img src="../../../assets/images/community.png" alt="Community Icon" />
      </div>
      <h3>Inforida Community</h3>
      <p>
        Connect with a vibrant<br />
        community of educators and<br />
        institutions for seamless collaboration<br />
        and networking.
      </p>
    </div>
  </div>
</div>

<app-job-footer></app-job-footer>
